<template>

  <section class="hero is-fullheight landing-wrapper">
    <PmNavbar />
    <OrderResetModal ref="orderResetModal"></OrderResetModal>
    <div class="hero-body">
      <div class="container">

        <div class="columns is-multiline is-equal-height">
          <div
            class="column is-6 green-bg landing-box py-5 is-flex is-flex-direction-column is-justify-content-space-around">
            <h1 class="font-30 is-abril-fatface has-text-weight-bold has-text-left" style="width: 100%;">{{
              this.$t("message.pages.landing.landingHeading") }}</h1>
            <div
              class="card-bod                                                                                                  y-text">
              <p class="font-15 mt-3 is-ubuntu has-text-left">{{ this.$t("message.pages.landing.landingTextOne") }}</p>
              <p class="font-15 mt-3 is-ubuntu has-text-left">{{ this.$t("message.pages.landing.landingTextTwo") }}</p>
              <p class="font-15 mt-3 is-ubuntu has-text-left">{{ this.$t("message.pages.landing.landingTextThree") }}
              </p>
            </div>
            <div class="finnish-flag-picture mt-3">
              <figure class="image">
                <img src="../assets/img/finnish_flag_key.png" style="height: 108px; width: 75px;" alt="Avainlippu" />
              </figure>
            </div>
          </div>
          <div class="column is-6 p-0 landing-image">
            <figure class="image">
              <img src="../assets/img/pyroll-landing-1.png" />
            </figure>
          </div>
        </div>

        <div class="columns is-multiline mt-5" v-if="getLandingContent != ''">
          <div class="column is-6 landing-box py-5 is-flex is-flex-direction-column is-justify-content-space-around">
            <div class="landing-page-content" v-html="getLandingContent.content"></div>
          </div>
          <div class="column is-6 p-0">
            <figure class="image">
              <img :src=getLandingContent.image />
            </figure>
          </div>
        </div>

        <div class="columns is-multiline">
          <div v-for="category in categories" :key="category.slug" class="column is-3 mb-2 category-card"
            @click="selectCategory(category)" :class="{ 'category-selected': category.slug === selectedCategory?.slug }"
            tabindex="0" role="button" :aria-label="category.name">
            <div class="box has-text-centered is-clickable">
              <p class="font-14">{{ category.name }}</p>
            </div>
          </div>

          <div v-if="selectedCategory" class="column is-12" id="products-list">
            <div class="columns is-multiline mt-5">
              <h3 class="column is-12 mb-4">
                {{ selectedCategory.name }}
              </h3>

              <div v-for="product in filteredProducts" :key="product.id" class="column is-3 mb-2">
                <div class="product-card">

                  <figure class="image product-image" @click="goToProductDetail(product.slug)">
                    <img :src="product.thumbnail" class="product-img" :alt="product.name" />
                  </figure>

                  <div class="card-content">
                    <p class="font-15 mt-1"><b>{{ product.name }}</b></p>

                    <p class="product-description font-13 mt-1">
                      {{ product.description.fi }}
                    </p>

                    <p v-if="product.resource_type == 'StoreProduct'" class="mt-1 font-13">
                      {{ product.price.toFixed(2) }} € alv 0%
                    </p>
                  </div>

                  <div class="card-footer mt-2">
                    <button v-if="product.resource_type == 'StoreProduct'" @click="goToProductDetail(product.slug)"
                      class="pyroll-button dark-blue-bg font-white">
                      {{ $t("message.pages.landing.addProduct") }}
                    </button>

                    <button v-else @click="goToProductDetail(product.slug)" class="pyroll-button green-bg font-white">
                      Tilaa tuote
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="columns is-multiline mb-6">
          <div
            class="column is-6 purple-bg landing-box py-5 is-flex is-flex-direction-column is-justify-content-space-around">
            <h1 class="has-text-centered font-30 is-abril-fatface has-text-weight-bold has-text-left font-white">{{
              this.$t("message.pages.landing.landingTextFour") }}</h1>
            <div class="card-bod y-text">
              <p class="has-text-centered font-13 mt-3 is-ubuntu has-text-left font-white">{{
                this.$t("message.pages.landing.landingTextFive") }}</p>
            </div>
          </div>
          <div
            class="column is-6 green-bg landing-box py-5 is-flex is-flex-direction-column is-justify-content-space-around">
            <h1 class="has-text-centered font-30 is-abril-fatface has-text-weight-bold has-text-left"
              style="width: 100%;">{{ this.$t("message.pages.landing.landingTextSix") }}</h1>
            <div class="card-bod y-text">
              <p class="has-text-centered font-13 mt-3 is-ubuntu has-text-left">{{
                this.$t("message.pages.landing.landingTextSeven") }}</p>
            </div>
          </div>
        </div>

        <div class="columns is-multiline is-equal-height notifications mb-6" v-if="landingNotification.active">
          <div class="column is-6 green-bg landing-box py-5 is-flex is-flex-direction-column is-justify-content-center">
            <h1 class="font-30 is-abril-fatface has-text-weight-bold has-text-left mb-5" style="width: 100%;">{{
              landingNotification.title }}</h1>
            <div class="card-body-text landing-page-content" v-html="landingNotification.text"></div>
          </div>
          <div class="column is-6 p-0 purple-bg is-align-content-center" style="justify-items: center;">
            <figure class="image" style="max-width: 325px;">
              <img :src="landingNotification.image" />
            </figure>
          </div>
        </div>

        <div class="columns is-multiline">
          <div class="column is-12 newsletter-signup-section">
            <h2 class="is-abril-fatface has-text-weight-bold">Tilaa Pyrollkaupan uutiskirje</h2>
            <p class="is-ubuntu mt-3">Saat tiedon uutisista, uutuuksista ja kampanjoista sähköpostiisi ensimmäisten
              joukossa!</p>

            <form action="https://packagemedia-oy.creamailer.fi/tilaa/QsarC6hPQMQnF" method="POST"
              class="newsletter-form mt-5" @submit="onNewsletterSubmit">
              <input name="cm_name" type="hidden" value="">

              <div class="field">
                <label class="label" for="userEmail">Sähköpostiosoite:</label>
                <div class="control">
                  <input class="input" type="mail" name="userEmail" id="userEmail" required>
                </div>
              </div>

              <div class="field">
                <label class="label" for="userName">Nimi:</label>
                <div class="control">
                  <input class="input" type="text" name="userName" id="userName">
                </div>
              </div>

              <div class="field">
                <label class="label" for="CM-YRITYS">Yritys:</label>
                <div class="control">
                  <input class="input" type="text" name="CM-YRITYS" id="CM-YRITYS">
                </div>
              </div>

              <div class="field newsletter-checkbox">
                <label class="checkbox">
                  <input type="checkbox" name="subscribePermission" id="subscribePermission" required>
                  Kyllä, tilaan uutiskirjeen
                </label>
              </div>

              <div class="field">
                <button type="submit" class="pyroll-button dark-blue-bg font-white mt-3">
                  Tilaa uutiskirje
                </button>
              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
    <NewsletterThanksModal ref="newsletterThanksModal" />
    <NewsletterErrorModal ref="newsletterErrorModal" />
    <PmFooter />
  </section>
</template>

<script>
import PmNavbar from '../components/PmNavbar'
import PmFooter from '../components/PmFooter'
import { mapActions, mapMutations } from 'vuex'
import { useState } from "vue-gtag-next"
import OrderResetModal from "@/modals/OrderResetModal"
import NewsletterThanksModal from '../modals/NewsletterThanksModal'
import NewsletterErrorModal from '../modals/NewsletterErrorModal'
import addProductMixin from "@/mixins/addProduct"
import { useHead } from '@vueuse/head'

export default {
  name: "LandingPage",
  components: {
    PmNavbar,
    PmFooter,
    OrderResetModal,
    NewsletterThanksModal,
    NewsletterErrorModal
  },
  data() {
    return {
      email: '',
      emailMessageError: false
    };
  },
  mixins: [addProductMixin],
  methods: {
    ...mapActions([
      'getProducts',
      'listDiscountVolumes',
      'listImageBank',
      'getServiceFees',
      'listShippingVoucher',
      'getLandingNotification'
    ]),
    ...mapMutations([
      'resetStore',
      'partialReset',
      'setOrder',
      'setReseting',
      'setSpinnerState',
      'setCartSpinnerState',
      'setResetOrderNotificationShow'
    ]),
    goToProductDetail(productSlug) {
      this.$router.push({
        name: "ProductDetail",
        params: {
          productSlug: productSlug
        },
      });
    },
    async onNewsletterSubmit(e) {
      e.preventDefault()
      const form = e.target
      const formData = new FormData(form)

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: formData,
          mode: 'no-cors'
        })

        // In no-cors mode, response.type is 'opaque' and status is 0.
        // A successful network request will reach here; a network error throws.
        if (response.ok || response.type === 'opaque') {
          form.reset()
          this.$refs.newsletterThanksModal.showModal()
        }
      } catch (error) {
        console.error('Newsletter subscription failed:', error)
        this.$refs.newsletterErrorModal.showModal()
      }
    },
    selectCategory(category) {
      this.$store.commit('setSelectedCategory', category.slug)

      this.$router.push(`/${category.slug}`)

      this.$nextTick(() => {
        const element = document.getElementById("products-list");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      })
    }
  },
  computed: {
    categories() {
      const map = new Map()

      this.$store.getters.getProducts.forEach(product => {
        product.categories?.forEach(category => {
          if (!map.has(category.slug)) {
            map.set(category.slug, category)
          }
        })
      })

      return Array.from(map.values())
    },
    filteredProducts() {
      if (!this.selectedCategory) return []

      return this.$store.getters.getProducts.filter(product =>
        product.categories?.some(
          category => category.slug === this.selectedCategory
        )
      )
    },
    selectedCategory() {
      return this.$store.getters.selectedCategory
    },
    getLandingContent() {
      if (this.$store.getters.landingData != undefined) {
        let results = this.$store.getters.landingData.results
        if (results.length > 0) {
          if (results[0]['content'] != '') {
            return results[0]
          }
        }
      }
      return ''
    },
    landingNotification() {
      return this.$store.getters.getLandingNotification
    }
  },
  watch: {
    '$route.params.categorySlug': {
      immediate: true,
      handler(slug) {
        if (!slug) return;

        const category = this.categories.find(
          c => c.slug === slug
        )

        if (category) {
          this.selectCategory(category)
        }
      }
    },
    selectedCategory: {
      immediate: true,
      handler(categorySlug) {
        if (!categorySlug) {
          useHead({
            title: 'Pyroll Kauppa',
            meta: [
              { name: 'description', content: 'Pyroll Kauppa' }
            ]
          })
          return
        }

        const category = this.categories.find(
          c => c.slug === categorySlug
        )

        if (category) {
          useHead({
            title: `${category.name} | Pyroll Kauppa`,
            meta: [
              {
                name: 'description',
                content: `${category.name} | Pyroll Kauppa`
              },
              {
                property: 'og:title',
                content: `${category.name} | Pyroll Kauppa`
              }
            ]
          })
        }
      }
    }
  },
  async mounted() {
    if (this.$store.getters.getResetOrderNotificationShow) {
      this.$refs.orderResetModal.showModal()
      this.setResetOrderNotificationShow(false)
    }
    if (this.$store.getters.getReseting) {
      this.setReseting(false)
      if (this.$store.getters.getAccountInfo == null) {
        this.resetStore()
      } else {
        this.partialReset()
      }
    }
    await Promise.all([  // dont block render
      this.getProducts(),
      this.listDiscountVolumes(),
      this.listImageBank(),
      this.getServiceFees(),
      this.listShippingVoucher(),
      this.getLandingNotification()
    ])
    this.setSpinnerState(false)
    this.setCartSpinnerState(false)
    // if user exists and enters app again we apply analytics again if enabled
    if (this.$store.getters.getGoogleCookieEnabled) {
      const { property } = useState();
      property.value = {
        id: process.env.VUE_APP_GA_ID
      }
    }

  },
};
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;

html {
  scroll-behavior: smooth;
}

.landing-wrapper {

  .cstm-chevron {}

  .main-button {
    width: 450px;

    @media (max-width: 768px) {
      transform: scale(0.6);
    }
  }

  .bg-image-blend {
    mix-blend-mode: multiply;
    background-image: url("../assets/img/cups_Kouvola_and_Kotka-9@2x.png");
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-size: contain;
    background-position-y: 100px;
    padding-bottom: 0 !important;

    @media (max-width: 768px) {
      background-position-y: 180px;
    }

    .top-landing-page-content {
      margin-top: 300px;
      padding: 0px;

      h1 {
        font-size: 45px;
        font-weight: bold;
      }

      h2 {
        font-size: 35px;
      }

      @media (max-width: 768px) {
        h1 {
          font-size: 25px;
        }

        h2 {
          font-size: 20px;
        }
      }

      @media (max-width: 768px) {
        padding: 20px;
        margin-top: 130px;
      }
    }
  }

  .img-container {
    height: 150px;
    flex-grow: 1;
  }

  .cstm-icon {
    height: 80px;
  }

  .blue-bg {
    background-color: $pm-light;
  }

  .blue-bg-transparent {
    background-color: rgba(50, 168, 183, 0.8)
  }

  .p-100 {
    padding-top: 100px;
  }

  .email-error {
    color: red;
    font-size: 18px;
    margin-top: 10px;
  }
}

.card-body-text {
  @media (max-width: 768px) {
    padding: 20px;
  }
}

.body-text {
  @media (max-width: 768px) {
    padding: 20px;
  }
}

.newsletter-section {
  background-color: $pyroll-violet !important;

  p.title {
    font-size: 25px;
    color: white;
  }

  p {
    font-size: 20px;
    color: white;
  }

  .newsletter-inputs {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;

    input {
      width: 440px;
      margin-right: 60px;
    }

    button.button {
      width: 220px;
    }
  }
}

.landing-box {
  @media (min-width: 769px) {
    padding: 100px;
  }
}

.finnish-flag-picture {
  text-align: left;
  width: 100%;
}

.product-description {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product-img {
  height: 250px;
  width: auto;
  margin: 0 auto;
}

.card-content {
  flex-grow: 1;
}

.card-footer {
  margin-top: auto;
}

.product-card button {
  width: 100%;
}

.product-card button {
  margin-top: auto;
}

.product-image:hover {
  cursor: pointer;
}

.box {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
}

.box:hover {
  background-color: #26D07C33;
}

.category-selected .box {
  background-color: #26D07C33;
}

:deep(.landing-page-content h1 span) {
  font-family: 'abrilfatface', "Abril Fatface";
  font-size: 30px;
  background-color: transparent !important;
  color: black !important;
  font-weight: bold;
}

:deep(.landing-page-content p span) {
  font-size: 15px;
  font-family: Ubuntu;
  background-color: transparent !important;
  color: black !important;
}

:deep(.landing-page-content p span a) {
  font-size: 15px;
  font-family: Ubuntu;
  background-color: transparent !important;
  color: black !important;
  text-decoration: underline !important;
  font-weight: bold;
}

.landing-image {
  display: flex;
}

.landing-image figure {
  flex: 1;
  margin: 0;
}

.landing-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.columns.is-equal-height {
  align-items: stretch;
}

.newsletter-signup-section {
  background-color: $pyroll-green;
  padding: 60px 80px;
  color: $pyroll-dark-blue;

  @media (max-width: 768px) {
    padding: 40px 28px;
  }

  h2 {
    font-size: 30px;
    color: $pyroll-dark-blue;
  }

  p {
    font-size: 16px;
    color: $pyroll-black;
    max-width: 600px;
  }

  .newsletter-form {
    max-width: 500px;

    .label {
      color: $pyroll-black;
      font-family: Ubuntu;
      font-weight: 600;
      font-size: 14px;
    }

    .input {
      border: 1px solid $pyroll-black;
      background-color: white;
      color: $pyroll-black;
      border-radius: 6px;
      padding: 10px 14px;
      font-size: 15px;
      height: auto;
      transition: border-color 0.2s, box-shadow 0.2s;

      &::placeholder {
        color: $pyroll-black;
      }

      &:focus {
        border-color: $pyroll-black;
        outline: none;
        box-shadow: 0 0 0 2px rgba(32, 21, 71, 0.15);
      }
    }

    .newsletter-checkbox {
      label {
        color: $pyroll-black;
        font-family: Ubuntu;
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      input[type="checkbox"] {
        width: 18px;
        height: 18px;
        accent-color: $pyroll-black;
        cursor: pointer;
        flex-shrink: 0;
      }
    }
  }
}
</style>
